import React from 'react'

const Sidebar = () => {
    return (
        <div className="hidden md:block border-r border-border bg-muted/20">
            sidebarok
        </div>
    )
};

export default Sidebar
